import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// Define the base URL for the AI Generation service
export const aiBaseUrl = "https://lcf.stmin.dev/api";

export const aiGenerationApi = createApi({
    reducerPath: "aiGenerationApi",
    baseQuery: fetchBaseQuery({
        baseUrl: aiBaseUrl,
        prepareHeaders: (headers) => {
            headers.set("Content-Type", "application/json");
            return headers;
        },
    }),
    endpoints: (builder) => ({
        generateQuizzes: builder.mutation({
            query: (payload) => ({
                url: "/generate-quizzes",
                method: "POST",
                body: payload,
            }),
        }),
        generateChapter: builder.mutation({
            query: (payload) => ({
                url: "/generate-chapter",
                method: "POST",
                body: payload,
            }),
        }),
        generateTopic: builder.mutation({
            query: (payload) => ({
                url: "/generate-topic",
                method: "POST",
                body: payload,
            }),
        }),
        generateSubtopic: builder.mutation({
            query: (payload) => ({
                url: "/generate-subtopic",
                method: "POST",
                body: payload,
            }),
        }),
    }),
});

export const {
    useGenerateQuizzesMutation,
    useGenerateChapterMutation,
    useGenerateTopicMutation,
    useGenerateSubtopicMutation
} = aiGenerationApi;
export default aiGenerationApi;
